<template>
  <div class="load-other">
    <div class="load" id="load" ref="load"></div>
    <div class="load-box">
      <div class="date">
        <div>
          <span>min</span>
          <span>max</span>
          <span>mvg</span>
          <span>curant*</span>
        </div>
      </div>
      <div class="date-box">
        <div class="left">
          <span></span>
          <span>15分钟负载</span>
        </div>
        <div class="right">
          <span>{{this.needData.minute.Min}}%</span>
          <span>{{this.needData.minute.Max}}%</span>
          <span>{{this.needData.minute.Mvg}}%</span>
          <span>{{this.needData.minute.Curant}}%</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:['needData'],
  mounted() {
    // setTimeout(()=>{
    //    this.load(this.needData);
    // },200)
    this.load(this.needData);
  },
  // watch: {
  //   'needData'() {
  //     this.load(this.needData);
  //   },
  // },
  methods: {
    load(param) {
      let myEchart = this.$echarts.init(document.getElementById("load"));
      // console.log(param);

      var date = []; 
      param.DateTime.forEach((item )=> {
        date.push(item.substring(item.length-5));
      });

      // var base = +new Date(2020, 0, 0);
      // var oneDay = 24 * 3600 * 1000;
      // var date = [];

      // var data = [Math.random() * 200];
      // var data2 = [Math.random() * 500];
      // var data3 = [Math.random() * 700];
      // var data4 = [Math.random() * 900];

      // for (var i = 1; i < 367; i++) {
      //   var now = new Date((base += oneDay));
      //   date.push(
      //     [now.getFullYear(), now.getMonth() + 1, now.getDate()].join("/")
      //   );
      //   data.push(Math.round((Math.random() - 0.5) * 20 + data[i - 1]));
      //   data2.push(Math.round((Math.random() - 0.5) * 20 + data2[i - 1]));
      //   data3.push(Math.round((Math.random() - 0.5) * 20 + data3[i - 1]));
      //   data4.push(Math.round((Math.random() - 0.5) * 20 + data4[i - 1]));
      // }

      let option = {
        grid: {
          top: "12%",
          left: "8%",
          bottom: "25%",
          right: "5%",
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: date,
          axisTick: {
              show: false,
            },
          // axisLabel: {
          //   formatter: function (value) {
          //     // 格式化成月/日，只在第一个刻度显示年份
          //     var date = new Date(value);
          //     var texts = [date.getMonth() + 1, date.getDate()];
          //     return texts.join("/");
          //   },
          // },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#526775",
            },
          },
        },
        yAxis: {
          type: "value",
          name: "(%)",
          nameGap: 10,
          nameTextStyle: {
            padding: [0, 40, 0, 0],
          },
          boundaryGap: [0, "100%"],
          splitLine: {
            show: true,
            lineStyle: {
              color: "#526775",
              type: "dashed",
            },
          },
        },
        series: [
          {
            name: "2020预算",
            type: "line",
            smooth: true,
            stack: "",
            symbol: "none",
            sampling: "average",
            lineStyle: {
              color: "#c7f4fc",
              width: 1,
              
            },
            // itemStyle: {
            //   // color: "#CA76C4",
            //   normal: {
            //     color: "#0092f6",
            //     lineStyle: {
            //       color: "#0092f6",
            //       width: 1,
            //     },
            //     // areaStyle: {
            //     //   //color: '#94C9EC'
            //     //   color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
            //     //     {
            //     //       offset: 0,
            //     //       color: "rgba(7,44,90,0.3)",
            //     //     },
            //     //     {
            //     //       offset: 1,
            //     //       color: "rgba(0,146,246,0.9)",
            //     //     },
            //     //   ]),
            //     // },
            //   },
            //   // markPoint: {
            //   //   itemStyle: {
            //   //     normal: {
            //   //       color: "red",
            //   //     },
            //   //   },
            //   // },
            // },
            data: param.Data1,
          },
          // {
          //   name: "2019预算",
          //   type: "line",
          //   smooth: true,
          //   symbol: "none",
          //   sampling: "average",
          //   lineStyle: {
          //     color: "#02d3f9",
          //     width: 1,
              
          //   },
          //   data: data2,
          // },
          // {
          //   name: "本行指标",
          //   type: "line",
          //   smooth: true,
          //   symbol: "none",
          //   sampling: "average",
          //   lineStyle: {
          //     color: "#e89d0a",
          //     width: 1,
              
          //   },
          //   data: data3,
          // },
          // {
          //   name: "2019同业",
          //   type: "line",
          //   smooth: true,
          //   symbol: "none",
          //   sampling: "average",
          //   lineStyle: {
          //     color: "#e72c2d",
          //     width: 1,
              
          //   },
          //   data: data4,
          // },
        ],
      };
      myEchart.setOption(option);
      window.addEventListener("resize", () => {
        myEchart.resize();
      });
    },
  },
};
</script>

<style scoped>
.load-other {
  width: 100%;
  height: 100%;
  position: relative;
}
.load {
  width: 100%;
  height: 100%;
}

.load-box {
  width: 95%;
  height: 4.5vh;
  position: absolute;
  bottom: 0;
  left: 3%;
}
.load-box .date {
  width: 100%;
  height: 1.6vh;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #00e4ff;
  font-size: 0.6vw;
}

.load-box .date div {
  width: 44%;
  height: 100%;
  align-items: center;
  justify-content: space-around;
}
.load-box .date div span {
  height: 100%;
  margin-right: 1.14vw;
  transform: scale(0.7);
  line-height: 1vh;
}

.load-box .date-box {
  width: 100%;
  height: 2.3vh;
  background: url('../../assets/img/74.png');
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.6vw;
}

.load-box .date-box .left {
  width: 18%;
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 0.6vw;
  justify-content: space-between;
  margin-left: 1vw;
}

.load-box .date-box .left span:nth-child(1) {
  width: 1.45vw;
  height: .7vh;
  background: red;
}
.load-box .date-box .left span:nth-child(2) {
  color: #aebfc4;
}

.load-box .date-box .right {
  width: 32%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #aebfc4;
  margin-right: 2.5vw;
}
</style>


